export const getNextApiUrl = (path: string) => {
  if (!path.startsWith("/")) path = `/${path}`;

  return `${window.location.origin}${path}`;
};
